const BASE = import.meta.env.VITE_WEBSITE_ANALYTICS_BASE;
const API_KEY = import.meta.env.VITE_WEBSITE_ANALYTICS_KEY;

async function postJSON(path, body) {
  const res = await fetch(`${BASE}/${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': API_KEY,
    },
    body: JSON.stringify(body || {}),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`${path} HTTP ${res.status}: ${text}`);
  }
  return res.json();
}

export function getSummary({ from, to }) {
  return postJSON('analyticsSummary', { from, to });
}

export function getTopPages({ from, to, limit = 20 }) {
  return postJSON('analyticsTopPages', { from, to, limit });
}

export function getTimeseries({ from, to }) {
  return postJSON('analyticsTimeseries', { from, to });
}

export function getRecentEvents({ limit = 50 }) {
  return postJSON('analyticsRecentEvents', { limit });
}
